// extracted by mini-css-extract-plugin
export default {"home":"HomeContainer_home__2yerO","componentContainer":"HomeContainer_componentContainer__IS3Ad"};